import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AppState } from '../../core';
import { PathTestDoc } from '../../core/schema/path-test-schema';
import {  ScoutPointPhotoService, ScoutPointPhotoUploadService } from '../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MapImageOverlay, MapRouteGPXOverlay } from '../../core/models';
import { MapImageOverlayComponent } from '../../shared/mapping/map-image-overlay/map-image-overlay.component';
import { MapRouteOverlayDoc } from '../../core/schema/route-overlay-schema';


@Component({
  selector: 'app-path-test-overlay',
  templateUrl: '../../shared/mapping/map-image-overlay/map-image-overlay.component.html',
  styleUrls: ['../../shared/mapping/map-image-overlay/map-image-overlay.component.scss']
})
export class PathTestOverlayComponent  extends MapImageOverlayComponent implements OnInit, OnDestroy {

  @Input() pathTestDoc : PathTestDoc
  
  @Input() MapRouteOverlayDoc: MapRouteOverlayDoc
  constructor( appState: AppState, 
      photoService : ScoutPointPhotoService,
      photoUploadService : ScoutPointPhotoUploadService,
      modalService : BsModalService ) { 
    super(appState,photoService,photoUploadService,modalService)
  }
  

  getOwnerId(): string {
    return this.pathTestDoc._id
  }
  
  
  getSharableOverlays(): { ownerId: string; ownerIndex: number; overlay: MapImageOverlay; }[] {
    return []
  }


  async saveOverlay(overlay: MapImageOverlay) {
    let oldImageId : string = null
    await this.pathTestDoc.atomicUpdate( (pathTest) => {
      //this.pathTestService.assignWhoAndWhenForPath(pathTest)          
      oldImageId = pathTest.overlay?.imageId
      pathTest.overlay = overlay
      return pathTest
    })
    return oldImageId
  }
  
}
